<!-- NAVBAR -->
<NavbarSection />

<!-- HERO SECTION -->
<HeroSection />

<!-- FEATURES SECTION -->
<FeaturesSection />

<!-- FOOTER -->
<FooterSection />